import React from 'react';
import { useContent } from '../ContentContext';
import { getIconComponent } from '../utils/iconMap';

const defaultHighlightIcons = [
  'BoltIcon',
  'MapIcon',
  'BuildingOfficeIcon',
  'AcademicCapIcon',
  'BookOpenIcon',
  'MapPinIcon'
];

const Highlights = () => {
  const { content } = useContent();
  const highlights = content.highlights;
  return (
    <section id="highlights" className="py-12 sm:py-24 px-4 sm:px-10 bg-white">
      <div className="container mx-auto text-center mb-10 sm:mb-20">
        <span className="text-[#EF5D22] font-bold tracking-widest uppercase text-xs sm:text-sm mb-3 sm:mb-4 block">{highlights.badge}</span>
        <h2 className="text-3xl sm:text-4xl lg:text-5xl font-extrabold mb-4 sm:mb-6 text-gray-900">
          {highlights.titlePart1} <span className="text-[#EF5D22]">{highlights.titlePart2}</span>
        </h2>
        <p className="text-gray-500 max-w-2xl mx-auto text-base sm:text-lg">
          {highlights.description}
        </p>
      </div>
      <div className="container mx-auto grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-10">
        {highlights.items.map((item: any, idx: number) => {
          const IconComponent = getIconComponent(item.icon || defaultHighlightIcons[idx]);
          return (
            <div key={idx} className="group p-6 sm:p-10 bg-white rounded-2xl sm:rounded-3xl hover:bg-gray-50 transition duration-500 border border-gray-100 hover:border-[#EF5D22]/20 shadow-sm hover:shadow-2xl text-left transform hover:-translate-y-2">
              <div className="w-12 h-12 sm:w-16 sm:h-16 bg-[#EF5D22]/5 rounded-xl sm:rounded-2xl flex items-center justify-center text-[#EF5D22] mb-5 sm:mb-8 group-hover:bg-[#EF5D22] group-hover:text-white transition-all duration-500">
                <IconComponent className="w-6 h-6 sm:w-8 sm:h-8" />
              </div>
              <h4 className="text-xl sm:text-2xl font-bold mb-3 sm:mb-4 text-gray-900 group-hover:text-[#EF5D22] transition-colors">{item.title}</h4>
              <p className="text-gray-600 leading-relaxed text-sm sm:text-base">{item.desc || item.description}</p>
            </div>
          );
        })}
      </div>
    </section>
  );
};

export default Highlights;
